import { httpPost } from './request/index'

// 分组
export function getGoodsTypeList (data) {
  return httpPost('/postHouse/goods/getGoodsTypeList', data)
}

// 商品列表查询
export function getGoodsList (data) {
  return httpPost('/postHouse/goods/getGoodsList', data)
}

// 查看
export function getGoodsDetails (data) {
  return httpPost('/postHouse/goods/getGoodsDetails', data)
}

// 删除
export function delById (data) {
  return httpPost('/postHouse/goods/delById', data)
}
